// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"48261b5c","787":"b086829a"}[chunkId] + ".chunk.js";
};